import React, { useEffect, useRef } from 'react';
import '../Styles/Hover.css'; 
import { FaStar, FaNetworkWired, FaUser, FaWallet, FaHandsHelping } from 'react-icons/fa';

const Hover = () => {

  const iconsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("icon-visible"); 
          }
        });
      },
      { threshold: 0.4 }
    );

    iconsRef.current.forEach(icon => {
      if (icon) observer.observe(icon);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="why-choose-us-section">

      <h2 className="section-title">
        Why <span className="highlight-orange">Choose</span> Us?
      </h2>

      <p className="section-description">
        With a legacy spanning over 50 years, Shanti Electricals has forged an unparalleled
reputation as a reliable partner in designing, supplying, installing, and commissioning MEP solutions across diverse applications. 
<br/>Stahllform Technik over the last 25 Years has positioned itself as a solution provider of premium electrical and automation panels and services.
      </p>

      {/* Row 1 */}
      <div className="features-grid">
        {[
          { icon: <FaStar />, title: 'Expertise and Experience', description: 'With decades of industry experience, we continue to bring expert solutions that drive measurable value for our customers' },
          { icon: <FaNetworkWired />, title: 'Extensive Network', description: 'We have established strong relationships with the leading companies in the region.' },
          { icon: <FaUser />, title: 'Personalized Approach', description: 'We believe that every customer is unique, and their needs should be addressed accordingly.' },
        ].map((feature, index) => (
          <div key={index} className="feature-card">
            <div
              className="icon-wrapper"
              ref={(el) => (iconsRef.current[index] = el)}
            >
              {feature.icon}
            </div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>

      {/* Row 2 */}
      <div className="features-row-center">
        {[
          { icon: <FaWallet />, title: 'Cost Savings', description: 'By leveraging our industry knowledge and network, we can help you save money.' },
          { icon: <FaHandsHelping />, title: 'Customer First Approach', description: 'We follow a customer-first approach, ensuring that every solution is designed around our clients’ needs.' },
        ].map((feature, index) => (
          <div key={index} className="feature-card">
            <div
              className="icon-wrapper"
              ref={(el) => (iconsRef.current[index + 3] = el)}
            >
              {feature.icon}
            </div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Hover;
